import Vue from 'vue';

import template from './navigation.html';

Vue.component('navigation', {
  template,
  props: [
    'slideText',
    'slideIndex',
    'lastSlide',
    'animating',
  ],
  methods: {
    changeSlide: function (increment) {
      this.$emit('slide', increment);
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js